import { getBugsnag } from 'utils/bugsnag';

export default function logError(exception) {
  const Bugsnag = getBugsnag();

  if (Bugsnag) {
    Bugsnag.notify(exception);
  }
  // eslint-disable-next-line no-console
  console.error(exception);
}
